/**
 * @file コンポーネント：フル動画ページノートボタン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledButton, StyledButtonIcon, StyledButtonText } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    return (
        <StyledButton onClick={(e) => props.fnOnClickNote(e)}>
            <StyledButtonIcon>
                <i className="fas fa-pen"></i>
            </StyledButtonIcon>
            <StyledButtonText>{localized["Label.Note"]}</StyledButtonText>
        </StyledButton>
    );
};
